/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class EventGroupAPI
 * @hideconstructor
 * @classdesc API class that contains event group functionality
 */
define([], () => {
	class EventGroupsAPI {

		/**
		 * @public
		 * @function EventGroupsAPI#groupExists
		 * @description Check if a group with the given group id exists
		 * @param {string} groupId - group id
		 * @returns {boolean} TRUE if the group exists and FALSE if it does not
		 */
		groupExists() {}

		/**
		 * @public
		 * @function EventGroupsAPI#getGroupId
		 * @description Get the group id of the given widget
		 * @param {string} widgetId - widget id
		 * @returns {string} group id
		 */
		getGroupId() {}

		/**
		 * @public
		 * @function EventGroupsAPI#getDefaultGroupId
		 * @description Given any content on a page, return the default groupId for that page.
		 * @param {contentAPI} content - the content api...could be the page itself or any content on a page.
		 * @returns {string} the default group id for the page that contains that content.
		 */
		getDefaultGroupId() {}

		/**
		 * @public
		 * @function EventGroups#getGroupIdsOnPage
		 * @description Get the ids of the groups on a given page
		 * @param {String} pageId - page id
		 * @returns {String[]} a list of the group ids for the page
		 */
		getGroupIdsOnPage() {}

		/**
		 * @public
		 * @function EventGroupsAPI#getContentIdList
		 * @description Get the content id list of the given group id
		 * @param {string} groupId - group id
		 * @returns {string[]} a list of content ids
		 */
		getContentIdList() {}

		/**
		 * @public
		 * @function EventGroupsAPI#addToGroup
		 * @description Add widgets to a group with the given group id. If the group doesn't exists it will be created
		 * @param {string} groupId - group id to add the widgets to
		 * @param {[string]} widgetIds - widget ids to add to the group
		 * @param {string} [transactionToken] - transaction token
		 */
		addToGroup() {}

		/**
		 * @public
		 * @function EventGroupsAPI#createGroup
		 * @description Create a new group with the given widget ids
		 * @param {[string]} widgetIds - widget ids to add to the new group
		 * @param {string} [transactionToken] - transaction token
		 * @returns {string} newly created group id
		 */
		createGroup() {}

		/**
		 * @public
		 * @function EventGroupsAPI#removeFromGroup
		 * @description Remove the given widgets from group to it's own groups
		 * @param {[string]} widgetIds - widget ids to remove from group
		 * @param {string} [transactionToken] - transaction token
		 * @returns {[string]} group ids
		 */
		removeFromGroup() {}

		/**
		 * @description Registers a EventGroups event handler.
		 * @function CanvasAPI#on
		 * @param {String} name Event name
		 * @param {Function} handler Event handler
		 * @return {Object} Object that has a remove function to remove the event handler.
		 */
		on() {}

		/**
		 * @description Deregisters a EventGroups event handler.
		 * @function CanvasAPI#off
		 * @public
		 * @param {String} name Event name
		 * @param {Function} name Event handler
		 */
		off() {}
	}

	return EventGroupsAPI;
});
